export const actionTypes = {
  SHOW_GLOBAL_MODAL: 'SHOW_GLOBAL_MODAL',
  HIDE_GLOBAL_MODAL: 'HIDE_GLOBAL_MODAL',
};

export const actions = {
  showGlobalModal: (params?: unknown) => ({
    type: actionTypes.SHOW_GLOBAL_MODAL,
    payload: params,
  }),
  hideGlobalModal: () => ({
    type: actionTypes.HIDE_GLOBAL_MODAL,
  }),
};
